import { shallowMount } from "@vue/test-utils";
import InformacionAdicional from "@/views/InformacionAdicional";

describe("InformacionAdicional component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(InformacionAdicional);
  });

  it("Renders del component InformacionAdicional", () => {
    expect(wrapper).toBeDefined();
  });

  it("Debe de establecer el valor por defecto", () => {
    expect(wrapper.text()).toContain("");
  });
});
